export var ClaimTypeCode;
(function (ClaimTypeCode) {
    ClaimTypeCode["pha"] = "pha";
    ClaimTypeCode["med"] = "med";
})(ClaimTypeCode || (ClaimTypeCode = {}));
//# sourceMappingURL=ClaimTypeCode.js.map